import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PrintSettings = ({ 
  settings, 
  onSettingsChange,
  onSliderChange 
}) => {
  const handleInputChange = (field, value) => {
    onSettingsChange(field, value);
  };

  const handleSliderChange = (field, value) => {
    onSliderChange(field, value);
  };

  return (
    <div className="bg-card rounded-2xl border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name="Settings" size={20} className="text-accent" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Configurações de Impressão</h3>
          <p className="text-sm text-muted-foreground">Defina os parâmetros do projeto</p>
        </div>
      </div>
      <div className="space-y-6">
        {/* Basic Settings */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Duração (horas)"
            type="number"
            placeholder="0"
            value={settings?.duration}
            onChange={(e) => handleInputChange('duration', e?.target?.value)}
            min="0"
            step="0.1"
            required
          />
          
          <Input
            label="Peso estimado (g)"
            type="number"
            placeholder="0"
            value={settings?.weight}
            onChange={(e) => handleInputChange('weight', e?.target?.value)}
            min="0"
            step="0.1"
            required
          />
        </div>

        {/* Infill Percentage Slider */}
        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">
            Preenchimento: {settings?.infill}%
          </label>
          <div className="relative">
            <input
              type="range"
              min="0"
              max="100"
              step="5"
              value={settings?.infill}
              onChange={(e) => handleSliderChange('infill', parseInt(e?.target?.value))}
              className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer slider"
            />
            <div className="flex justify-between text-xs text-muted-foreground mt-1">
              <span>0%</span>
              <span>25%</span>
              <span>50%</span>
              <span>75%</span>
              <span>100%</span>
            </div>
          </div>
        </div>

        {/* Print Speed Slider */}
        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">
            Velocidade: {settings?.speed}mm/s
          </label>
          <div className="relative">
            <input
              type="range"
              min="20"
              max="100"
              step="5"
              value={settings?.speed}
              onChange={(e) => handleSliderChange('speed', parseInt(e?.target?.value))}
              className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer slider"
            />
            <div className="flex justify-between text-xs text-muted-foreground mt-1">
              <span>20mm/s</span>
              <span>40mm/s</span>
              <span>60mm/s</span>
              <span>80mm/s</span>
              <span>100mm/s</span>
            </div>
          </div>
        </div>

        {/* Layer Height Slider */}
        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">
            Altura da camada: {settings?.layerHeight}mm
          </label>
          <div className="relative">
            <input
              type="range"
              min="0.1"
              max="0.4"
              step="0.05"
              value={settings?.layerHeight}
              onChange={(e) => handleSliderChange('layerHeight', parseFloat(e?.target?.value))}
              className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer slider"
            />
            <div className="flex justify-between text-xs text-muted-foreground mt-1">
              <span>0.1mm</span>
              <span>0.2mm</span>
              <span>0.3mm</span>
              <span>0.4mm</span>
            </div>
          </div>
        </div>

        {/* Support Material */}
        <div className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
          <div>
            <div className="font-medium text-foreground">Material de suporte</div>
            <div className="text-sm text-muted-foreground">Adiciona 15-25% ao custo do material</div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={settings?.supportMaterial}
              onChange={(e) => handleInputChange('supportMaterial', e?.target?.checked)}
              className="sr-only peer"
            />
            <div className="relative w-11 h-6 bg-muted peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
          </label>
        </div>

        {/* Quantity */}
        <Input
          label="Quantidade"
          type="number"
          placeholder="1"
          value={settings?.quantity}
          onChange={(e) => handleInputChange('quantity', e?.target?.value)}
          min="1"
          required
          description="Número de peças a serem impressas"
        />
      </div>
      <style jsx>{`
        .slider::-webkit-slider-thumb {
          appearance: none;
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: var(--color-primary);
          cursor: pointer;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
        
        .slider::-moz-range-thumb {
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: var(--color-primary);
          cursor: pointer;
          border: none;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default PrintSettings;